const size = {
  desktop: '2560px',
  laptop: '1024px',
  laptopL: '1440px',
  mobileL: '425px',
  mobileM: '375px',
  mobileS: '320px',
  tablet: '768px',
}

export default {
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  midSize: '(min-width: 768px) and (max-width: 1120px)',
  mobileL: `(max-width: ${size.mobileL})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileS: `(max-width: ${size.mobileS})`,
  print: `print`,
  tablet: `(max-width: ${size.tablet})`,
};



// WEBPACK FOOTER //
// ./src/State/Devices.tsx